
import { throwError as observableThrowError, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

@Injectable()
export class PasswordService {
    constructor(private http: Http) { }

    emailPassword(username: string) {
        let url = `${environment.api.serviceurl}` + "ForgotPassword?uname=" + username;
        return this.http.get(url).pipe(
            map((response: Response) => {
                let abc = response.json();
                return abc.ForgotPasswordResult;
            }));
    }

    emailpassword(username: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "forgotPassword";
        let orderData = username;
        let headers = new Headers({ 'Content-Type': 'application/json' });;
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractdata),
            catchError(this.handleError),);
    }

    changePassword(customerID: string, oldPassword: string, newPassword: string) {
        let url = `${environment.api.serviceurl}` + "ChangePassword?customerid=" + customerID + "&oldpassword=" + oldPassword + "&newpassword=" + newPassword;
        return this.http.get(url).pipe(
            map((response: Response) => {
                let abc = response.json();
                return abc.ChangePasswordResult;
            }));
    }

    changepassword(customerId: string, oldPassword: string, newPassword: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "changePassword";
        let orderData = { "customerid": customerId, "oldpassword": oldPassword, "newpassword": newPassword };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractdata),
            catchError(this.handleError),);
    }

    private extractdata(res: Response) {
        let body = res.json();
        return body.orderid || {};
    }

    private extractData(res: Response) {
        let body = res.json();
        if (body.status == "OK") {
            let jsonbody = JSON.parse(body.orderid);
            return jsonbody || {};
        } else {
            observableThrowError(body.message);
            return []
        }
    }

    private handleError(error: any) {
        let errMsg = '';
        if (error.message) {
            errMsg = error.message;
        } else {
            errMsg = error.status ? '${error.status} - ${error.statusText}' : 'Server error';
        }
        return observableThrowError(errMsg);
    }
}